import { inject, observer } from 'mobx-react';
import * as React from 'react';
import { ChannelList, Spinner } from 'telia-front-react';
import TvChannelsStore, { TvChannel } from '../stores/TvChannelsStore';
import { TranslationsContext } from '@teliaee/telia-translate';
import { prepareChannels } from '../util/TvChannelUtil';

export interface TvChannelProps {
  packetGroupId?: number;
  iconSize?: string;
  size?: 'small' | 'medium' | 'large';
  align?: 'center' | 'right';
  color?: 'inverse';
  className?: string;
  tvChannelsStore?: TvChannelsStore;
}

interface TvChannelListProps extends TvChannelProps {
  packetId?: number;
  items?: TvChannel[];
}

@observer
class TvChannelList extends React.Component<TvChannelListProps> {
  static contextType = TranslationsContext;
  declare context: React.ContextType<typeof TranslationsContext>;

  public componentDidMount() {
    const { packetGroupId, packetId, tvChannelsStore, items } = this.props;
    if (!items) {
      tvChannelsStore.loadTvPacket(packetGroupId, packetId);
    }
  }

  public render() {
    const { tvChannelsStore, iconSize, size, align, color, className, items, packetGroupId, packetId } = this.props;
    const translate = this.context.translate;
    let channels;
    if (!items) {
      if (tvChannelsStore.notFound(packetGroupId, packetId)) {
        return null;
      } else if (tvChannelsStore.isFetching(packetGroupId, packetId)) {
        return <Spinner />;
      }
      channels = prepareChannels(tvChannelsStore.getTvPacket(packetGroupId, packetId).channels, translate, size, iconSize);
    } else {
      channels = prepareChannels(items, translate, size, iconSize);
    }
    return <ChannelList items={channels} size={size} align={align} color={color} className={className} />;
  }
}

export default inject('tvChannelsStore')(TvChannelList);
